// @flow
import React from 'react';
import classnames from 'classnames';
import { getFormattedDate } from 'src/modules/get-formatted-date';

import { Text, TextLink } from 'seek-style-guide/react';

import NavLink from 'src/components/NavLink/NavLink';
import StatusMessage from 'src/components/StatusMessage/StatusMessage';

import styles from './JobApplyMessage.less';

type Props = {
  appliedDateUTC?: string,
  isOnStickyApply?: boolean,
  isLinkOut: boolean,
  isScreenAssigned?: boolean,
  isSelectionCriteriaEnabled?: boolean
};

const JobApplyMessage = ({
  appliedDateUTC,
  isOnStickyApply,
  isScreenAssigned,
  isSelectionCriteriaEnabled,
  isLinkOut
}: Props) => {
  const linkoutDescriptionCopy = `${
    isOnStickyApply
      ? 'Applications will open'
      : 'Applications for this role will take you to'
  } the advertiser’s site.`;
  const dateAppliedFormatted = appliedDateUTC
    ? getFormattedDate(appliedDateUTC)
    : '';

  const automationText = `job-detail-${
    isLinkOut ? 'linkout-clicked' : 'applied'
  }-description'`;
  const appliedMessage = `${
    isLinkOut ? 'Apply clicked' : 'You applied'
  } on ${dateAppliedFormatted}`;

  return (
    <div className={styles.root}>
      {dateAppliedFormatted && (
        <StatusMessage positive dataAutomation={automationText}>
          {appliedMessage}
        </StatusMessage>
      )}
      {isLinkOut && (
        <Text
          small
          raw
          secondary
          data-automation="job-detail-linkout-description"
        >
          <span
            className={classnames({
              [styles.linkoutDescription]: isOnStickyApply
            })}
          >
            {linkoutDescriptionCopy}
          </span>
        </Text>
      )}
      {!isOnStickyApply && [
        isScreenAssigned && (
          <Text
            key="additional-info"
            small
            raw
            secondary
            data-automation="job-detail-screen-info"
          >
            This advertiser has requested additional information before you
            apply.
          </Text>
        ),
        isSelectionCriteriaEnabled && (
          <Text
            key="selection-info"
            small
            raw
            secondary
            data-automation="job-detail-selection-info"
          >
            You may need to tell this advertiser how your skills and experience
            meet their selection criteria.&nbsp;
            <NavLink
              location="/career-advice/tag/Government%20Selection%20Criteria"
              component={TextLink}
              rel="nofollow"
            >
              View tips
            </NavLink>
          </Text>
        )
      ]}
    </div>
  );
};

JobApplyMessage.defaultProps = {
  isOnStickyApply: false,
  isLinkOut: false,
  isScreenAssigned: false,
  isSelectionCriteriaEnabled: false
};

export default JobApplyMessage;
